import React from "react";
import { useNavigate } from "react-router-dom";
import mern from "../assets/course/mern.png";
import datascience from "../assets/course/datascience.jpg";
import reactnative from "../assets/course/reactnative.png";
import backgroundImage from "../assets/background.jpg"; // Placeholder for background image
import { FaWhatsapp } from "react-icons/fa";

const JoinClass = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen text-white"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#1e3a8a",
        background: `linear-gradient(135deg, rgba(30, 58, 138, 0.8), rgba(6, 182, 212, 0.8)), url(${backgroundImage})`,
      }}
    >
      {/* Hero Banner */}
      <div className="bg-black/30 backdrop-blur-sm text-white py-12 px-4 md:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 animate-fade-in">
            Join Our Upcoming Classes
            <span className="block text-yellow-500 mt-2">
              Start Learning Today!
            </span>
          </h1>
          <p className="text-lg md:text-xl max-w-2xl mx-auto">
            Explore our upcoming courses and secure your spot in the next batch.
            Your journey to mastering new skills starts here!
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-8 md:py-12">
        {/* Upcoming Classes */}
        <div className="mt-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 flex items-center">
            Upcoming Classes
            <select className="ml-4 p-2 border rounded-md text-blue-500 text-sm bg-white shadow-sm">
              <option>Starts Every Sunday</option>
            </select>
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {/* MERN */}
            <div className="bg-white/10 backdrop-blur-sm rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
              <img src={mern} alt="MERN" className="w-full h-48 object-cover" />
              <div className="p-6">
                <span className="inline-block bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded mb-2">
                  45 days
                </span>
                <h3 className="text-xl font-semibold text-white">
                  MERN Training
                </h3>
                <p className="text-gray-200 text-sm mt-2">
                  Class Timing:
                  <br />
                  6:00 AM - 7:00 AM
                  <br />
                  7:00 AM - 8:00 AM
                </p>
                <button
                  onClick={() => navigate("/courses/full-stack-mern")}
                  className="mt-4 w-full bg-blue-600 text-white py-2 rounded-md font-semibold hover:bg-blue-700 transition-colors duration-200"
                >
                  Learn More
                </button>
              </div>
            </div>
            {/* Data Science Training */}
            <div className="bg-white/10 backdrop-blur-sm rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
              <img
                src={datascience}
                alt="Data Science Training"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <span className="inline-block bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded mb-2">
                  30 days
                </span>
                <h3 className="text-xl font-semibold text-white">
                  Data Science Training
                </h3>
                <p className="text-gray-200 text-sm mt-2">
                  Class Timing:
                  <br />
                  6:00 AM - 7:00 AM
                  <br />
                  7:00 AM - 8:00 AM
                </p>
                <button
                  onClick={() => navigate("/courses/data-science")}
                  className="mt-4 w-full bg-blue-600 text-white py-2 rounded-md font-semibold hover:bg-blue-700 transition-colors duration-200"
                >
                  Learn More
                </button>
              </div>
            </div>
            {/* Mobile App Training */}
            <div className="bg-white/10 backdrop-blur-sm rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300">
              <img
                src={reactnative}
                alt="Mobile App Training"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <span className="inline-block bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded mb-2">
                  45 days
                </span>
                <h3 className="text-xl font-semibold text-white">
                  Mobile App Development
                </h3>
                <p className="text-gray-200 text-sm mt-2">
                  Class Timing:
                  <br />
                  6:00 AM - 7:00 AM
                  <br />
                  7:00 AM - 8:00 AM
                </p>
                <button
                  onClick={() => navigate("/courses/react-native")}
                  className="mt-4 w-full bg-blue-600 text-white py-2 rounded-md font-semibold hover:bg-blue-700 transition-colors duration-200"
                >
                  Learn More
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/9779849489441"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-4 sm:right-6 top-1/2 transform -translate-y-1/2 bg-green-500 text-white p-3 sm:p-4 rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300 z-50"
        aria-label="Chat with us on WhatsApp"
      >
        <FaWhatsapp className="w-6 h-6 animate-spin-slow" />
      </a>

      {/* Inline CSS for Animations and Responsive Adjustments */}
      <style>
        {`
          @keyframes fade-in {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-in {
            animation: fade-in 1s ease-out;
          }
          .hover\\:scale-105:hover {
            transform: scale(1.05);
          }
          @keyframes spin-slow {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .animate-spin-slow {
            animation: spin-slow 4s linear infinite;
          }

          /* Disable fixed background on mobile for performance */
          @media (max-width: 640px) {
            div[style*="background-attachment: fixed"] {
              background-attachment: scroll;
            }
            .fixed.right-4.sm\\:right-6 {
              right: 2rem;
              padding: 0.75rem;
            }
            .fixed.right-4.sm\\:right-6 .w-6.h-6 {
              width: 1.25rem;
              height: 1.25rem;
            }
            .grid > div {
              margin-bottom: 1.5rem;
            }
            .grid img {
              height: 10rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default JoinClass;
